import { gql } from '@apollo/client';

const HOLTER_EVENTS_QUERY = gql`
  query holterEvents($filter: HolterEventsFilter!, $limit: Int) {
    holterEvents(filter: $filter, limit: $limit) {
      isSuccess
      message
      events {
        id
        start
        stop
        type
        minHr
        maxHr
        avgHr
        isReviewed
        channel
        comment
        isCaptured
        title
        countBeats
        duration
        strips {
          images
          id
          draw
          isSelected
          start
          stop
          comment
          noiseChannels
          channel
          userUpdated
        }
      }
    }
  }
`;

export default HOLTER_EVENTS_QUERY;
